// https://confluence.vk.team/pages/viewpage.action?pageId=1560502237

type OperationFlag = 'READ_FLAG' | 'DOWNLOAD_FLAG' | 'EDIT_FLAG' | 'CREATE_FLAG' | 'DELETE_FLAG' | 'SHARE_FLAG' | 'ACCESS_DENIED_FLAG';

const BITMASK_MAPPER: Record<OperationFlag, number> = {
    // 0. Просмотр в редакторе, версий и истории
    READ_FLAG: 0,
    // 1. Скачивание файлов / папок
    DOWNLOAD_FLAG: 1,
    // 2. Редактирование, переименование
    EDIT_FLAG: 2,
    // 3. Создание, загрузка, копирование, перемещение
    CREATE_FLAG: 3,
    // 4. Удаление, восстановление, доступ к корзине
    DELETE_FLAG: 4,
    // 5. Создание ссылок с наследованием прав
    SHARE_FLAG: 5,
    // 24. Запрет доступа
    ACCESS_DENIED_FLAG: 24,
};

const isBitSet = (mask: number, bitIndex: number): boolean => (mask & (1 << bitIndex)) > 0;

export const hasAccessDenied = (mask: number) => isBitSet(mask, BITMASK_MAPPER.ACCESS_DENIED_FLAG);
export const getAccessDeniedMask = () => 1 << BITMASK_MAPPER.ACCESS_DENIED_FLAG;
export const getFullAccessMask = () => ~(1 << BITMASK_MAPPER.ACCESS_DENIED_FLAG) >>> 0;

export type DomainFolderBitmaskParams = Record<OperationFlag, boolean>;

export const getDomainFoldersBitmaskParams = (bitMask = 0): DomainFolderBitmaskParams => {
    return Object.keys(BITMASK_MAPPER).reduce(
        (result, flag) => ({ ...result, [flag]: isBitSet(bitMask, BITMASK_MAPPER[flag]) }),
        {} as DomainFolderBitmaskParams
    );
};
